import { Http } from './http';

export const GetAssociations = (params) => Http().get(`/account?${params}`);

export const GetAccounts = (params) => Http().get(`/account/global-search?${params}`);
export const CreateAssociation = (body) => Http().post(`/account`, body);
